import { render, staticRenderFns } from "./downloadTableImg.vue?vue&type=template&id=183d5320&"
import script from "./downloadTableImg.vue?vue&type=script&lang=js&"
export * from "./downloadTableImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports